(function ($) {
  var stickyFilters = {
    animCtrl: new ScrollMagic.Controller(),
    wrapperQuery: ".component-archive-filters",
    $wrapperEl: undefined,
    scenes: {
      sticky: undefined,
    },
    trackSticky: function () {
      this.scenes.sticky = new ScrollMagic.Scene({
        triggerElement: this.wrapperQuery,
        triggerHook: 0,
      })
        .setPin(this.wrapperQuery, { pushFollowers: true })
        .setClassToggle(this.wrapperQuery, "sticky")
        .addTo(this.animCtrl);
    },
    trackReduced: function () {
      this.scenes.sticky = new ScrollMagic.Scene({
        triggerElement: this.wrapperQuery,
        triggerHook: 0,
      })
        .setPin(this.wrapperQuery, { pushFollowers: true })
        .setClassToggle(this.wrapperQuery, "reduced")
        .addTo(this.animCtrl);
    },
    init: function () {
      this.$wrapperEl = $(this.wrapperQuery);
      this.trackSticky();
      this.trackReduced();
      return this;
    },
  }.init();
})(jQuery);
